export var CHIP_THEMES = {
  light: {
    "default": {
      borderColorClassname: 'border-gray-main',
      fontColorClassname: 'text-base-lighter',
      hoverBorderColorClassname: 'hover:border-primary-lighter',
      hoverFontColorClassname: 'hover:text-primary-lighter',
      deleteIconBackgroundHoverClassname: 'hover:bg-base-light',
      deleteIconHoverColorClassname: 'hover:text-white',
      deleteIconColorClassname: 'text-base-main'
    },
    active: {
      backgroundColorClassname: 'bg-primary-lighter',
      fontColorClassname: 'text-white',
      borderColorClassname: 'border-primary-lighter'
    },
    disabled: {
      fontColorClassname: 'text-gray-dark',
      borderColorClassname: 'border-gray-main',
      backgroundColorClassname: 'bg-gray-main'
    }
  },
  dark: {
    "default": {
      borderColorClassname: 'border-base-lighter',
      fontColorClassname: 'text-gray-main',
      hoverBorderColorClassname: 'hover:border-secondary-light',
      hoverFontColorClassname: 'hover:text-secondary-light',
      deleteIconBackgroundHoverClassname: 'hover:bg-secondary-light',
      deleteIconHoverColorClassname: 'hover:text-base-dark',
      deleteIconColorClassname: 'text-secondary-light'
    },
    active: {
      backgroundColorClassname: 'bg-secondary-light',
      fontColorClassname: 'text-base-main',
      borderColorClassname: 'border-secondary-light'
    },
    disabled: {
      fontColorClassname: 'text-gray-dark',
      borderColorClassname: 'border-gray-main',
      backgroundColorClassname: 'bg-gray-main'
    }
  }
};